import clsx from 'clsx';
import { Trophy } from 'lucide-react';
import { GAME_KINDS, KIND_NAMES, type GameKind } from '@mafia/core';
import { Badge } from './ui';

/** Значок турнирной игры; любительские — без значка (их большинство). */
export function KindBadge({ kind, showAmateur = false }: { kind: GameKind; showAmateur?: boolean }) {
  if (kind === 'TOURNAMENT') {
    return (
      <Badge tone="gold">
        <Trophy className="h-3 w-3" /> Турнир
      </Badge>
    );
  }
  return showAmateur ? <Badge>Любительская</Badge> : null;
}

const PLURAL: Record<GameKind, string> = { AMATEUR: 'Любительские', TOURNAMENT: 'Турнирные' };

/** Переключатель вида игр. withAll — добавить вариант «Все игры». */
export function KindTabs<T extends GameKind | 'ALL'>({
  value,
  onChange,
  withAll = false,
  labels = 'plural',
}: {
  value: T;
  onChange(v: T): void;
  withAll?: boolean;
  labels?: 'plural' | 'single';
}) {
  const options = [...(withAll ? (['ALL'] as const) : []), ...GAME_KINDS] as T[];
  return (
    <div className="inline-flex rounded-xl bg-ink-900 p-1" role="tablist">
      {options.map((o) => (
        <button
          key={o}
          // Переключатель живёт и внутри форм — он не должен их отправлять.
          type="button"
          role="tab"
          aria-selected={o === value}
          onClick={() => onChange(o)}
          className={clsx('rounded-lg px-3 py-1.5 text-sm transition', o === value ? 'bg-white/10 text-white' : 'text-zinc-500 hover:text-zinc-300')}
        >
          {o === 'ALL' ? 'Все игры' : labels === 'plural' ? PLURAL[o as GameKind] : KIND_NAMES[o as GameKind]}
        </button>
      ))}
    </div>
  );
}
